import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { SidebarItem } from '../../interfaces/ISidebarItem';
import { AuthService } from '../../services/auth-service/auth.service';

@Component({
  selector: 'gains-sidenav',
  standalone: false,
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss'
})
export class SidebarComponent implements OnInit {
  @Output() toggleSidebarEvent = new EventEmitter<boolean>();
  sidebarOpen = true;
  username = 'User';

  constructor(
    private _authService: AuthService,
    private _modal: NzModalService
  ) {}

  async ngOnInit() {
    await this._authService.ready;
    this.username = this._authService.getUsername() ?? 'User';
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
    this.toggleSidebarEvent.emit(this.sidebarOpen);
  }

  logout(): void {
    this._modal.confirm({
      nzTitle: 'Logout Confirmation',
      nzContent: 'Are you sure you want to logout?',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOnOk: () => this._authService.logout(),
      nzCancelText: 'No'
    });
  }

  menuItems: SidebarItem[] = [
    // { route: '/dashboard', icon: 'assets/icons/dashboard.svg', text: 'Dashboard' },
    // { route: '/finance', icon: 'assets/icons/finance.svg', text: 'Finances' },
    { route: '/client', icon: 'assets/icons/clients.svg', text: 'Clients' },
    { route: '/team', icon: 'assets/icons/teams.svg', text: 'Teams soon...' },
    { route: '/partner', icon: 'assets/icons/partners.svg', text: 'Partners' },
    { route: '/alert', icon: 'assets/icons/alerts.svg', text: 'Alerts' },
    { route: '/report', icon: 'assets/icons/reports.svg', text: 'Reports soon...' }
  ];

  footerItems: SidebarItem[] = [
    // { route: '/notifications', icon: 'assets/icons/notification.svg', text: 'Notifications' },
    // { route: '/settings', icon: 'assets/icons/setting.svg', text: 'Settings' }
  ];

  userItem = {
    route: '/userprofile',
    icon: 'assets/icons/clients.svg'
  };
}
